import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router";
import {
  Breadcrumbs,
  Button,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
  Tabs,
} from "InnoUI/components";
import SC from "./style";
import { useSelector } from "react-redux";
import {
  AddAdditionalContact,
  OccupantNameDropdown,
  OccupantNumberDropdown,
  RemoveFromProjectComponent,
} from "components";
import { useSearchParams } from "react-router-dom";
import { innoTableConfig, InnoTableDefaultPageSize } from "utils/config";
import { apiDelete, apiGet, apiPost } from "api/callApi";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import theme from "@theme/";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {
  decryptCrypto,
  formatPhoneNumber,
  getNestedAccess,
  showAlert,
} from "utils/helper";
import { getCompany } from "@store/company/actions";
import { getRoleOptions } from "@store/roleOptions/actions";
import { useDispatch } from "react-redux";
import InnoIcons from "@InnoIcons/";
import AddEditUser from "views/AdminSettings/Users/AddEditUser";
import TooltipText from "components/TooltipText";
import AssignRoles from "views/AdminSettings/Users/AssignRoles";
import SendCredential from "views/AdminSettings/Users/SendCredential";
import AssignOccupant from "views/AdminSettings/Users/AssignOccupant";
import AssignUser from "views/AdminSettings/Projects/AssignUser";
import AssignUserToOccupant from "components/AssignUserToOccupant";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import CheckPermissionWrapper from "components/CheckPermissionWrapper";
import { userAccessType } from "utils/lookUpTable";
import { Switch } from "antd";

const AddressBook = (props) => {
  const { hide, setCount = () => {}, popupState } = props;
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  //const occupantId = searchParams.get("occupantId");
  const [data, setData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [openButton, setOpenButton] = useState(null);
  const [openAddEditDrawer, setOpenAddEditDrawer] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [fieldData, setFieldData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openAssignRoleDrawer, setOpenAssignRoleDrawer] = useState(false);
  const [openModalView, setOpenModalView] = useState(false);
  const [openCredentialView, setOpenCredentialView] = useState(false);
  const [openRemoveFromProject, setOpenRemoveFromProject] = useState(false);
  const [openAssignProjectDrawer, setOpenAssignProjectDrawer] = useState(false);
  const [openAssignUserDrawer, setopenAssignUserDrawer] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [openAssignModalView, setOpenAssignModalView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const dispatch = useDispatch();

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || []
  );

  const accessControlData = useSelector(
    (state) => state?.accessControlData?.data || []
  );

  const companyData = useSelector((state) => state.companyData || []);
  const roleData = useSelector((state) => state.roleOptionData || []);

  useEffect(() => {
    dispatch(getCompany());
    dispatch(getRoleOptions());
  }, []);

  const roleFilter = {
    filters: roleData?.data?.map((option) => ({
      text: option.role,
      value: option.role,
    })),
    filterSearch: true,
    onFilter: (value, record) => {
      return record["roles"]
        ?.split(",")
        .map((r) => r.trim())
        .includes(value);
    },
  };

  const companyFilter = {
    filters: companyData?.data?.map((option) => ({
      text: option.companyName,
      value: option.companyName,
    })),
    filterSearch: true,
    onFilter: (value, record) => record["companyName"] === value,
  };

  const getAddressBookData = async () => {
    try {
      const url = !hide
        ? `/v1/addressbook/${projectId}/${type}`
        : `/v1/addressbook/${projectId}/${type}?primaryContact=${1}`;
      setIsLoading(true);
      const response = await apiGet(url);
      const mergedData = response.data;
      setData(mergedData);
      setOriginalData(mergedData); // Store original
      setPropertyData(response.propertyDetails[0]);
      setCount(mergedData.length);
      setIsLoading(false);
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAddressBookData();
  }, [projectId]);

  const [searchText, setSearchText] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    if (!value) {
      setData(originalData); // Reset to original
      return;
    }

    const filtered = originalData.filter((item) => {
      return (
        item?.fullName?.toLowerCase().includes(value) ||
        item?.companyName?.toLowerCase().includes(value) ||
        item?.roles?.toLowerCase().includes(value)
      );
    });

    setData(filtered);
  };

  const handleRemoveFromP = async (id) => {
    try {
      const response = await apiPost(`/v1/removefromproject`, {
        projectId: projectId,
        projectType: type,
        userIds: selectedItems,
      });
      showAlert({ title: "Success", text: response.message, icon: "success" });
      setOpenRemoveFromProject(false);
      await getAddressBookData();
      setSelectedItems([]);
    } catch (error) {
      console.log("Error", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });
    }
  };

  const closeAssignUserDrawer = () => {
    setopenAssignUserDrawer(false);
    setIsEditing(false);
    setOpenButton(null);
  };

  const closeAssignProjectDrawer = () => {
    setOpenAssignProjectDrawer(false);
    setIsEditing(false);
  };

  const onAssignOccupantClick = (data) => {
    setFieldData(data);
    setOpenAssignProjectDrawer(true);
  };

  const handleOpenRemoveModal = () => {
    setOpenRemoveFromProject(true);
    setFieldData(data);
  };

  const handleCloseRemove = () => {
    setOpenRemoveFromProject(false);
    setOpenButton(null);
  };

  const handleCredentialOption = async (record) => {
    setOpenCredentialView(true);
    // setFieldId(record.id);
    setFieldData(record);
  };

  const handleAddUserModalOccupant = () => {
    setOpenModalView(true);
    // setopenAssignUserDrawer(true);
  };
  const handleAddUserModalProject = () => {
    // setOpenModalView(true);
    setopenAssignUserDrawer(true);
  };

  const handleCloseModal = () => {
    setOpenModalView(false);
    setOpenButton(null);
  };

  const handleEditUser = (data) => {
    setIsEditing(true);
    // setFieldId(data.id);
    setFieldData(data);
    setOpenAddEditDrawer(true);
  };

  const closeAddEditDrawer = () => {
    setOpenAddEditDrawer(false);
    setIsEditing(false);
  };

  const handleAddUser = () => {
    setOpenAddEditDrawer(true);
    setIsEditing(false);
  };

  const closeAssignRoleDrawer = () => {
    setOpenAssignRoleDrawer(false);
    setIsEditing(false);
  };

  const onAssignRoleClick = (data) => {
    // setFieldId(data.id);
    setFieldData(data);
    setOpenAssignRoleDrawer(true);
  };

  const handleAssignUserModal = () => {
    setOpenAssignModalView(true);
  };
  const handlePrimaryContact = async (userId, checked) => {
    try {
      const response = await apiPost("/v1/addressbook/manageprimarycontact", {
        userIds: [userId],
        projectId: currentProject?.id,
        status: checked,
        occupantId: currentOccupant?.id,
      });
      // showAlert({ title: "Success", text: response.message, icon: "success" });
      await getAddressBookData();
    } catch (error) {
      console.log("Error", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });
    }
  };

  console.log(data, "data");

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 50,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <p>{serialNumber}</p>;
      },
    },

    {
      title: "Full Name",
      dataIndex: "fullName",
      width: 200,
      onCell: () => ({
        style: {},
      }),
      //
      render(value, record) {
        const actionsConfig = [
          {
            key: "canEditUser",
            text: "Edit",
            onClick: () => handleEditUser(record),
          },
          {
            key: "canManageUserProject",
            text: "Manage User Projects",
            onClick: () => onAssignOccupantClick(record),
          },
          {
            key: "canAssignRoles",
            text: "Assign Roles",
            onClick: () => onAssignRoleClick(record),
          },

          {
            key: "canSendUserCredential",
            text: "Send Credentials",
            onClick: () => handleCredentialOption(record),
          },
        ];
        const menuItems = actionsConfig.filter(
          (action) => accessControlData[action.key]
        );

        return (
          <SC.PopoverContainer>
            <TooltipText title={value} maxLength={0} />
            {!hide && menuItems.length > 0 && (
              <Popover
                sx={{
                  cursor: "pointer",
                }}
                buttonLabel={{
                  icon: (
                    <>
                      <div
                        style={{
                          width: "50px",
                          textAlign: "center",
                          justifyContent: "end",
                          display: "flex",
                          marginRight: "5px",
                        }}
                      >
                        <SC.PopoverSpan>
                          <SC.MoreVertIcon />
                        </SC.PopoverSpan>
                      </div>
                    </>
                  ),
                }}
                popoverContent={
                  <TableList
                    sx={{
                      borderBottom: `1px solid ${theme.colors.bordertask}`,
                    }}
                    items={menuItems || []}
                    popupState={popupState}
                  />
                }
              />
            )}
          </SC.PopoverContainer>
        );
      },
    },

    {
      title: "Company Name",
      dataIndex: "companyName",
      width: 200,
      render(value, record) {
        return <p>{value || "N/A"}</p>;
      },
      ...companyFilter,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 250,
      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Contact No",
      dataIndex: "cell",
      width: 150,
      render(value, record) {
        return (
          <p>
            {formatPhoneNumber(record.cellCode, decryptCrypto(record.cell)) ||
              "N/A"}
          </p>
        );
      },
    },
    {
      title: "Role",
      dataIndex: "roles",
      render(value, record) {
        return (
          value && (
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <p
                    style={{
                      whiteSpace: "normal",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "100%",
                      padding: "2px",
                    }}
                  >
                    {value}
                  </p>
                ),
              }}
              popoverContent={
                <table style={{ width: "200px" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          color: theme.colors.themeColor,
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                          textAlign: "left",
                        }}
                      >
                        Roles
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td
                        style={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                      >
                        {value || "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            />
          )
        );
      },
      ...roleFilter,
    },
    ...(type == 1 && !hide
      ? [
          {
            title: "Primary Contact",
            dataIndex: "primaryContact",
            width: "200px",
            render(value, record) {
              return (
                <Switch
                  checked={value}
                  onChange={(checked) =>
                    handlePrimaryContact(record.id, checked)
                  }
                  style={{
                    transform: "scale(0.7)",
                    backgroundColor: value
                      ? theme.colors.themeColor
                      : undefined,
                    borderColor: value ? theme.colors.themeColor : undefined,
                  }}
                />
              );
            },
          },
        ]
      : []),
  ];

  const actionButtons = [
    {
      key: "edit",
      caption: "New User",
      icon: (isActive) => (
        <InnoIcons.AddIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleAddUserModalOccupant,
      accessKey: "canAddUserToProject",
    },
    ...(type == 1
      ? [
          {
            key: "assignuser",
            caption: "Assign Users",
            icon: (isActive) => (
              <InnoIcons.AddIcon
                sx={{
                  fontSize: "12px",
                  color: isActive ? "white" : theme.colors.themeColor,
                }}
              />
            ),
            onClick: handleAssignUserModal,
            accessKey: "canAssignUserToOccupant",
          },
        ]
      : []),
    {
      key: "remove",
      caption: type == 0 ? "Remove from Project" : "Remove from Occupant",
      icon: (isActive, isDisabled) => (
        <InnoIcons.DeleteIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleOpenRemoveModal,
      accessKey: "canRemoveUsersFromProject",
      disabled: () => selectedItems.length == 0,
    },
  ];

  const canRemoveUsers = actionButtons.some(
    (btn) =>
      btn.key === "remove" && getNestedAccess(accessControlData, btn.accessKey)
  );

  const tableConfig = {
    draggable: false,
    selection: !hide ? canRemoveUsers : false,
    expandable: true,
    sno: false,
    addNew: false,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    search: false,
    action: false,
    divBorder: false,
  };

  const checkboxChangeCallback = (data, state) => {
    if (state === true) {
      setSelectedItems([data, ...selectedItems]); // create new array
    } else {
      const newData = selectedItems.filter((item) => item !== data);
      setSelectedItems(newData);
    }
  };

  const allCheckboxChangeCallback = (data, state) => {
    if (state == true) {
      setSelectedItems(data);
    } else {
      setSelectedItems([]);
    }
  };

  return (
    <>
      {!hide && (
        <>
          {/* <SC.BodyHeader> */}
          <CustomBreadcrumb />
          {/* </SC.BodyHeader> */}

          <SC.BodyContainer>
            <SC.FilterContainer>
              <OccupantFilterDropdown />
            </SC.FilterContainer>
          </SC.BodyContainer>
        </>
      )}

      <CheckPermissionWrapper>
        {({ permission }) => (
          <>
            {(permission == userAccessType.write ||
              permission == userAccessType.read ||
              permission === undefined) && (
              <>
                <SC.Container>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      padding: "10px",
                    }}
                  >
                    <div
                      style={{
                        borderRight: "1px solid #d9d9d9",
                        flex: 1,
                      }}
                    >
                      {!hide && (
                        <SC.TabDiv>
                          <SC.HeaderContainer>
                            <SC.HeadingTag>Address Book</SC.HeadingTag>
                          </SC.HeaderContainer>

                          <form
                            autoComplete="off"
                            onSubmit={(event) => {
                              event.preventDefault();
                            }}
                          >
                            <SC.InputContiner>
                              <SC.SearchIcon />
                              <SC.InputStyle
                                placeholder="Search"
                                name="searchJournal"
                                onChange={handleSearch}
                                autoComplete="off"
                              />
                            </SC.InputContiner>
                          </form>
                        </SC.TabDiv>
                      )}

                      {!hide && (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            padding: "5px",
                            marginLeft: "15px",
                            // borderBottom: `1px solid ${theme.colors.bordertask}`,
                          }}
                        >
                          {actionButtons
                            .filter((btn) =>
                              getNestedAccess(accessControlData, btn.accessKey)
                            )
                            .map((btn) => {
                              const isActive = openButton === btn.key;
                              const isDisabled =
                                typeof btn.disabled === "function"
                                  ? btn.disabled()
                                  : btn.disabled;

                              return (
                                <Button
                                  key={btn.key}
                                  leftIcon={btn.icon(isActive)}
                                  caption={btn.caption}
                                  fontSize="11px"
                                  color={
                                    isActive ? "white" : theme.colors.themeColor
                                  }
                                  onClick={() => {
                                    setOpenButton(btn.key);
                                    btn.onClick();
                                  }}
                                  disabled={isDisabled}
                                  style={{
                                    background: isDisabled
                                      ? "#f0f0f0"
                                      : isActive
                                      ? theme.colors.themeColor
                                      : theme.colors.white,

                                    minWidth: "100px",
                                    borderRadius: "3px",
                                    height: "28px",
                                    fontSize: "12px",
                                    border: `1px solid ${theme.colors.themeColor}`,
                                  }}
                                />
                              );
                            })}
                        </div>
                      )}
                      <InnoTable
                        tableConfig={tableConfig}
                        loading={isLoading}
                        padding="4px 8px"
                        column={subColumnData}
                        data={data}
                        tableKey="Project"
                        searchKeys={["fullName", "companyName", "roles"]}
                        selectedItems={selectedItems}
                        checkboxChangeCallback={checkboxChangeCallback}
                        allCheckboxChangeCallback={allCheckboxChangeCallback}
                      />
                    </div>
                    <div style={{ padding: "10px" }}>
                      <h3>Property Contact</h3>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                          Name:
                        </span>
                        <p
                          style={{
                            fontSize: "13px",
                            paddingBlock: "0px",
                            marginBlock: "0px",
                          }}
                        >
                          {propertyData?.fullName || "N/A"}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                          Contact No:
                        </span>
                        <p
                          style={{
                            fontSize: "13px",
                            paddingBlock: "0px",
                            marginBlock: "0px",
                          }}
                        >
                          {formatPhoneNumber(
                            propertyData?.cellCode,
                            propertyData?.cell
                          ) || "N/A"}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                          Email:
                        </span>
                        <p
                          style={{
                            fontSize: "13px",
                            paddingBlock: "0px",
                            marginBlock: "0px",
                          }}
                        >
                          {propertyData?.email || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </SC.Container>
              </>
            )}
          </>
        )}
      </CheckPermissionWrapper>

      {openAddEditDrawer && (
        <DetailDrawer
          open={openAddEditDrawer}
          onClose={closeAddEditDrawer}
          width={"650px"}
          children={
            <AddEditUser
              userdata={fieldData}
              onClose={closeAddEditDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              fetchData={getAddressBookData}
              isDisabled={true}
            />
          }
        />
      )}
      {openModalView && (
        <AddAdditionalContact
          openModalView={openModalView}
          onClose={handleCloseModal}
          createTO={true}
          // setPropData={setData}
        />
      )}
      {openAssignRoleDrawer && (
        <DetailDrawer
          open={openAssignRoleDrawer}
          onClose={closeAssignRoleDrawer}
          width={"750px"}
          children={
            <AssignRoles
              userdata={fieldData}
              onClose={closeAssignRoleDrawer}
              fetchData={getAddressBookData}
              // defaultProject={userProjectId}
              setOpenAssignRoleDrawer={setOpenAssignRoleDrawer}
              // setCurrentPage={setCurrentPage}
              addressBook={true}
              defaultProject={currentProject?.id}
            />
          }
        />
      )}
      {openCredentialView && (
        <SendCredential
          title={"Send Credentials"}
          handleShow={setOpenCredentialView}
          isOpen={openCredentialView}
          data={fieldData}
        />
      )}
      {openRemoveFromProject && (
        <RemoveFromProjectComponent
          title={"Remove From Project"}
          // messageData={`Are you sure you want to delete user ${
          //   fieldData?.fullName || ""
          // }?`}
          setOpenDeleteView={setOpenRemoveFromProject}
          openDeleteView={openRemoveFromProject}
          handleDelete={() => handleRemoveFromP(fieldData.id)}
          handleArchive={handleCloseRemove}
          firstButtontext={"Cancel"}
        />
      )}
      {openAssignModalView && (
        <AssignUserToOccupant
          setOpenAssignModalView={setOpenAssignModalView}
          openAssignModalView={openAssignModalView}
          setOpenButton={setOpenButton}
          fetchData={getAddressBookData}
          occupantUser={data}

          // roleId={roleId}
        />
      )}
      {openAssignProjectDrawer && (
        <DetailDrawer
          open={openAssignProjectDrawer}
          onClose={closeAssignProjectDrawer}
          width={"50%"}
          children={
            <AssignOccupant
              userdata={fieldData}
              onClose={closeAssignProjectDrawer}
              fetchData={getAddressBookData}
              setOpenAssignProjectDrawer={setOpenAssignProjectDrawer}
              // setCurrentPage={setCurrentPage}
              defaultProject={currentProject?.id}
              addressBook={true}
            />
          }
        />
      )}

      {openAssignUserDrawer && (
        <DetailDrawer
          open={openAssignUserDrawer}
          onClose={closeAssignUserDrawer}
          width={"70%"}
          children={
            <AssignUser
              // userdata={fieldData}
              onClose={closeAssignUserDrawer}
              project={currentProject}
              // fetchData={getAlldata}
              isDisabled={true}
              hideColumns={["cell", "userType", "createdAt", "roleNames"]}
            />
          }
        />
      )}
    </>
  );
};

export default AddressBook;
